import { toast } from 'sonner';
import { esEncolada, mensajeError } from '@/api/cliente';

/** Muestra el error de una operación; si solo quedó guardada para enviarse sin conexión, avisa sin alarmar. */
export function avisarError(error: unknown): void {
  if (esEncolada(error)) toast.info(mensajeError(error));
  else toast.error(mensajeError(error));
}
